var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "giftcode-detail" }, [
    _c("div", { staticClass: "game-page" }, [
      _c(
        "div",
        { staticClass: "game-page__header" },
        [
          _c("v-container", [
            _vm.status.loading_game
              ? _c(
                  "div",
                  [
                    _c("v-skeleton-loader", {
                      attrs: { tile: "", type: "list-item-avatar-two-line" },
                    }),
                  ],
                  1
                )
              : _c("div", [
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "item__image" }, [
                      _c("img", {
                        attrs: { src: _vm.gameById.icon, alt: "", srcset: "" },
                      }),
                    ]),
                    _c("div", { staticClass: "item__content" }, [
                      _c("div", { staticClass: "item__title" }, [
                        _vm._v(_vm._s(_vm.gameById.name)),
                      ]),
                      _c("div", { staticClass: "item__type" }, [
                        _vm._v(_vm._s(_vm.gameById.type)),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "item__button",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.downloadGame(_vm.gameById)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../assets/icons/down.svg"),
                            alt: "",
                            srcset: "",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
          ]),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "giftcode-detail__content" },
      [
        _c(
          "v-container",
          [
            _c(
              "div",
              { staticClass: "home-item" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { staticClass: "text-center", attrs: { cols: "6" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "home-item__btn",
                            attrs: {
                              depressed: "",
                              outlined: "",
                              large: "",
                              width: "100%",
                              color: "#e88d50",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.homePage(_vm.gameById)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "home-item__text",
                                attrs: { color: "#e88d50" },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/icons/home.svg"),
                                    alt: "",
                                    srcset: "",
                                  },
                                }),
                                _c("span", { staticClass: "white--text" }, [
                                  _vm._v("Trang chủ"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "text-center", attrs: { cols: "6" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "home-item__btn facebook",
                            attrs: {
                              depressed: "",
                              outlined: "",
                              large: "",
                              width: "100%",
                              color: "#e88d50",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goFanpage(_vm.gameById)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "home-item__text",
                                attrs: { color: "#e88d50" },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../assets/icons/facebook.svg"),
                                    alt: "",
                                    srcset: "",
                                  },
                                }),
                                _c("span", { staticClass: "white--text" }, [
                                  _vm._v("Fanpage"),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-card",
              { staticClass: "giftcode-card", attrs: { outlined: "" } },
              [
                _c("Recieved", {
                  attrs: {
                    zalo_contact: _vm.gameById.admin_zalo,
                    game_alias: _vm.gameById.alias,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }